import { gql } from '@urql/core'
import { ApiMutationInput } from 'interfaces'

export const IS_USERNAME_AVAILABLE = gql`
  query IsUsernameAvailable($input: IsUsernameAvailableInput!) {
    isUsernameAvailable(input: $input)
  }
`

export type IsUsernameAvailableVars = ApiMutationInput<
  Record<'username', string>
>
export interface IsUsernameAvailableResponse {
  isUsernameAvailable: boolean
}
